import React from "react";

import GenericField from "./shared/GenericField";
import SelectInputContainer from "./select/SelectInputContainer";

/**
 * Select between the given selectable options. "Option" object: {string id, string name}.
 * @param {string} [label] Label description for field input.
 * @param {string} [icon] Icon next to input, see ./shared/FormatHelpers.js/getIconClassName for available icons.
 * @param {option} [initialValue] Field value.
 * @param {list<option>} [options] Selectable options.
 * @param {function} [handleSave] [async option=>{bool success, string message}] Save changes / return error message.
 */
const Select = ({
    label,
    icon: iconName,
    initialValue,
    options,
    handleSave: syncChanges,
}) => {
    return (
        <GenericField>
            {label}
            <SelectInputContainer
                {...{ iconName, initialValue, options, syncChanges }}
            />
        </GenericField>
    );
};

export default Select;
